import { Component, Input, OnInit } from '@angular/core';
import { ILayoutSettings, IPageContent } from '@app/feature/store-editor/components/layout/store-editor.interface';
import { CommonService } from '@app/feature/store-editor/services/common.service';

@Component({
  selector: 'app-slider-setting',
  templateUrl: './slider-setting.component.html',
  styleUrls: ['../styling/styling.component.css']
})
export class SliderSettingComponent implements OnInit {
  @Input() item: IPageContent;
  @Input() layoutSetting: ILayoutSettings;

  constructor(private cs: CommonService) {
  }

  ngOnInit() {
   
  }

  removeSlider(selectedSlider: number) {
    this.item.data.images.splice(selectedSlider, 1);
  }

  imageSelector(image: string) {
    if (image) {
      return image;
    } else {
      return '/assets/img/imagePlaceholder.png';
    }
  }
  selectFileToSlider(el: any, sliderNumber: number) {
    const input = el.target.files[0];

    const reader = new FileReader();
    reader.readAsDataURL(input);
    reader.onload = () => {
      if (sliderNumber === -1) {

        this.item.data.images.push({
          image: reader.result.toString(),
          active: true,
          translateX: 0
        });

        this.cs.uploadFile(input.name, reader.result.toString()).then(res => this.item.data.images[this.item.data.images.length - 1].image = res);
      } else {
        this.item.data.images[sliderNumber].image = reader.result.toString();
        this.cs.uploadFile(input.name, reader.result.toString()).then(res => this.item.data.images[sliderNumber].image = res);
      }
    };
  }

}
